import { CamelCasedPropertiesDeep, SnakeCasedPropertiesDeep } from "../types/conversion-types";

export function snakeToCamel<T extends object>(value: T): CamelCasedPropertiesDeep<T> {
  if (Array.isArray(value)) {
    return value.map(snakeToCamel) as CamelCasedPropertiesDeep<T>;
  } else if (typeof value === "function" || value !== Object(value)) {
    return value as CamelCasedPropertiesDeep<T>;
  }
  return Object.fromEntries(
    Object.entries(value).map(([k, v]) => {
      return [
        k.replaceAll(/_([a-z])/g, (_, letter) => letter.toUpperCase()),
        typeof v === "object" ? snakeToCamel(v) : v
      ];
    })
  ) as CamelCasedPropertiesDeep<T>; // Object.entries wipes out original type info so have to cast here
}

export function camelToSnake<T extends object>(value: T): SnakeCasedPropertiesDeep<T> {
  if (Array.isArray(value)) {
    return value.map(camelToSnake) as SnakeCasedPropertiesDeep<T>;
  } else if (typeof value === "function" || value !== Object(value)) {
    return value as SnakeCasedPropertiesDeep<T>;
  }
  return Object.fromEntries(
    Object.entries(value).map(([k, v]) => {
      return [
        k.replaceAll(/([A-Z])/g, (_, letter) => `_${letter.toLowerCase()}`), //
        typeof v === "object" ? camelToSnake(v) : v
      ];
    })
  ) as SnakeCasedPropertiesDeep<T>; // Object.entries wipes out original type info so have to cast here
}
